<template>
  <div>
    <el-card class="box-card">
      <el-input
        style="width: 100%"
        size="small"
        clearable
        placeholder="输入内容进行过滤"
        v-model="filterText"
        :disabled="treeData.length == 0"
      >
      </el-input>
      <el-tree
        style="margin-top: 5px"
        v-loading="treeLoading"
        :data="data"
        show-checkbox
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
        @check-change="clickTree"
        :filter-node-method="filterNode"
      >
      </el-tree>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "TreeCommon",
  props: {
    treeData: {
      type: Array,
      default: {
        return: [],
      },
    },
  },
  data() {
    return {
      data: this.treeData,
      filterText: "",
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      treeValue: [],
    };
  },
  mounted() {},
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    clickTree(data) {
      // console.log(data);
      if (data.id != "00") {
        this.treeValue.push(data);
      }
    },
  },
  watch: {
    treeData: function (nval) {
      // console.log(nval, 222);
      if (nval.length > 0) {
        this.data = nval;
      }
    },
    filterText: function (val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped lang="scss">
.box-card {
  max-height: 270px;
}
.el-tree {
  width: 100%;
  display: inline-block;
  overflow-y: auto;
  overflow-x: scroll;
  overflow: auto;
  max-height: 200px;
}
</style>
